export default __webpack_public_path__ + "static/media/reg_1.593aedea.jpg";